<template>
  <el-popover
    ref="volume-control"
    :popper-options="{ boundariesElement: 'body', gpuAcceleration: false, positionFixed: false }"
    :append-to-body="false"
    placement="top"
    popper-class="volume-control"
    trigger="click"
    @hide="hide"
  >
    <el-slider
      v-model="volumeLevel"
      :show-tooltip="false"
      vertical
      height="197px"
      @input="onChange"
    />
    <div
      slot="reference"
      class="cursor-pointer"
      @click="togglePopup">
      <svg svg-inline="" class="volume-svg" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 16"><defs><path id="volumeControl_svg__a" d="M16.2674626,1.71943081 C16.630187,1.35504827 17.2196659,1.3533901 17.5857066,1.71611447 C19.1319488,3.26608753 20,5.366158 20,7.55535503 C20,9.7445521 19.1319488,11.8450371 17.5857066,13.3945956 C17.2180077,13.7361783 16.6446959,13.7266438 16.2902624,13.3717958 C15.9354143,13.0157041 15.9242217,12.4440505 16.2674626,12.0763516 C17.4625876,10.8766666 18.1345604,9.25083238 18.1345604,7.5570132 C18.1345604,5.86319402 17.4625876,4.23735976 16.2674626,3.03767481 C15.90308,2.67329227 15.90308,2.08381335 16.2674626,1.71943081 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g fill="#FFFFFF" transform="translate(-51.000000, -273.000000) translate(51.000000, 273.000000)"><path d="M10.506156,0.155363325 C10.8995564,0.375485205 11.1424781,0.790027345 11.1441363,1.24187827 L11.1441363,13.8754645 C11.1441363,14.3256572 10.9012146,14.7401994 10.5094723,14.9603212 C10.1173154,15.1825158 9.63644654,15.1725668 9.25258052,14.9395941 L4.18438834,11.8500116 L2.79815943,11.8500116 C1.25357543,11.8500116 -9.9475983e-14,10.5964362 -9.9475983e-14,9.05185215 L-9.9475983e-14,6.06549059 C-9.9475983e-14,4.52090658 1.25357543,3.26733115 2.79815943,3.26733115 L4.18604651,3.26733115 L9.26252954,0.177748605 C9.64307922,-0.0502495752 10.1173154,-0.0601985852 10.506156,0.155363325 Z M1.86543962,9.05185215 C1.86543962,9.56671349 2.2832981,9.984572 2.79815943,9.984572 L3.57874228,9.984572 L3.57874228,5.13277078 L2.79815943,5.13277078 C2.2832981,5.13277078 1.86543962,5.55062925 1.86543962,6.06549059 L1.86543962,9.05185215 Z M9.27703851,12.7827314 L9.27703851,2.34787669 L5.4441819,4.68589435 L5.4441819,10.4314484 L9.27703851,12.7827314 Z"/><path d="M13.0274012,4.30700284 C13.202338,4.12916426 13.4419434,4.02843052 13.6910832,4.02843052 C13.9406376,4.02843052 14.1802429,4.12916426 14.3551797,4.30700284 C16.1460017,6.10279938 16.1460017,9.00791068 14.3551797,10.8037072 C13.9907972,11.1714061 13.3980019,11.1730643 13.0323757,10.8086817 C12.666335,10.4459574 12.6630187,9.8531621 13.0274012,9.48546323 C14.0927745,8.42008993 14.0927745,6.6922783 13.0274012,5.62524684 C12.6646769,5.2608643 12.6646769,4.67138538 13.0274012,4.30700284 L13.0274012,4.30700284 Z"/><use xlink:href="#volumeControl_svg__a"/></g></g></g></svg>
    </div>
  </el-popover>
</template>

<script>
import volumeIcon from '../assets/images/volumeControl.svg';

export default {
  props: {
    playerId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      volumeLevel: 100,
      showPopup: false,
      volumeIcon,
    };
  },
  methods: {
    onChange() {
      const player = document.getElementById(this.playerId);
      if (player) {
        player.volume = this.volumeLevel / 100;
      }
    },
    togglePopup() {
      this.showPopup = !this.showPopup;

      if (this.showPopup) {
        document.addEventListener('keydown', this.keydownListener);
      }
    },
    hide() {
      this.showPopup = false;

      document.removeEventListener('keydown', this.keydownListener);
    },
    keydownListener(e) {
      if (e.keyCode === 38) {
        this.volumeLevel += 5;
      } else if (e.keyCode === 40) {
        this.volumeLevel -= 5;
      }

      this.onChange();
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.volume-control {
  min-width: auto !important;
  padding-top: 20px !important;
  padding-bottom: 20px !important;

  .el-slider__runway {
    background-color: rgba(0, 174, 203, 0.3);
  }

}
.volume-svg {
  width: 24px;
  margin-top: 2px;
}
</style>
